/* @flow */

import { compose } from 'ramda';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  getEventNavbarSponsors,
  getEventSponsorLogo,
  getEventSponsorLink,
  getEventSponsorName,
} from '@e180/domain/lib/event/util';

import NavSponsorBrandingDumb from './NavSponsorBrandingDumb';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  // Self passed
  intl: intlShape,
};

const mapStateToProps = (state: State, { intl }: Props): Object => {
  const { locale } = intl;
  const sponsors = getEventNavbarSponsors(getEventSafely(state));

  return {
    // @TODO: make that editable via the plugin
    tagline: null,
    sponsors: sponsors.map((sponsor) => ({
      name: getEventSponsorName(sponsor, locale),
      logo: getEventSponsorLogo(sponsor),
      url: getEventSponsorLink(sponsor),
    })),
  };
};

export default compose(
  injectIntl,
  connect(mapStateToProps),
)(NavSponsorBrandingDumb);
